import { combineReducers } from "redux";
import prompt from "./snackbar/reducer";
import loader from "./loader/reducer";
import authReducer from "./common/reducer";
import menuReducer from "./menu/reducer";
import expiryReducer from "./expiry/reducer";
import businessReducer from "./business/reducer";
import organizationReducer from "./organization/reducer";

const rootReducer = combineReducers({
  snackbar: prompt,
  loader: loader,
  authReducer: authReducer,
  menuReducer: menuReducer,
  expiryReducer: expiryReducer,
  businessReducer: businessReducer,
  organizationReducer: organizationReducer,
});

export default rootReducer;
